import * as React from "react";
import { forwardRef } from "react";

const SvgAwscli = ({
  title,
  titleId,
  ...props
}, ref) => <svg id="svg1450" width={218.14561} height={221.46703} viewBox="0 0 218.14561 221.46703" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<defs id="defs1454" localstack-color="#ff9801" /><g id="g1456" transform="translate(-192.20604,-209.16759)"><path style={{
      fill: "#ff9801",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2,
      strokeMiterlimit: 11.7
    }} d="m 193.48352,250.61264 96.70329,33.01923 1.63462,147.00275 -99.61539,-38.87913 z" id="path2111" /><path style={{
      fill: "#ff9801",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2,
      strokeMiterlimit: 11.7
    }} d="m 313.67582,284.64835 0.57143,142.84616 95.33517,-33.40935 0.76923,-141.92582 z" id="path2113" /><path style={{
      fill: "#ff9801",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2,
      strokeMiterlimit: 11.7
    }} d="m 211.72802,236.90659 94.89561,33.3077 89.66758,-30.0055 -90.7033,-31.04121 z" id="path2115" /></g></svg>;

const ForwardRef = forwardRef(SvgAwscli);
export default ForwardRef;